<template>
  <section></section>
</template>

<script>
import { mapState } from "vuex";
import router from "@/router";
export default {
  name: "PID",
  data() {
    return {
      token: null,
      msisdn: null,
    };
  },
  mounted() {
    this.$store.state.cellcardFramePotrait = true;
    this.goTo("login");
  },
  computed: {
    ...mapState(["user", "cellcardFramePotrait"]),
  },
  methods: {
    goTo(page) {
      router.push({ name: page });
    },
  },
};
</script>

<style scoped></style>
